import React from "react";
import useStyles from "./styles";
import { Box, Typography } from "@material-ui/core";

const DisplayWebLink = ({ url, isDashboard = false, viewDetails }) => {
  const classes = useStyles();

  return (
    <Box height="100%" width="100%" className={`${classes.linkMetaData}`}>
      {isDashboard ? (
        <img
          src={viewDetails?.image}
          width="100%"
          height="100%"
          className={classes.linkImgDashboard}
          
        />
      ) : (
        <a href={url} target="_blank" className={classes.metaInfoWrapper}>
          <img src={viewDetails?.image} width="100%" height="100%" />
          <Box className={classes.metaInfo}>
            <Typography className="font-12 multi-wrap-2" variant="body2">
              {viewDetails?.title}
            </Typography>
            <Typography
              className="font-12 f-light-gray truncate-txt"
              variant="body2"
            >
              {viewDetails?.url}
            </Typography>
          </Box>
        </a>
      )}
    </Box>
    // <Box
    //   height="100%"
    //   width="100%"
    //   className={`${classes.videoThumbnail} video-thumb`}>
    //   {isDashboard ? (
    //     <Fragment width="100%" height="100%">
    //       {getVideoThumbnail(url)}
    //       <span className={classes.playIcon}>
    //         <PlayArrowIcon />
    //       </span>
    //     </Fragment>
    //   ) : (
    //     <ReactPlayer url={url} controls={true} width="100%" height={"100%"} />
    //   )}
    // </Box>
  );
};

export default DisplayWebLink;

/**
 * https://www.linkpreview.net/
 * https://ritekit.com/api-demo/link-preview
 * https://www.opengraph.io/pricing/
 */
